import {useEffect, useState} from "react";
import {mrbgStore} from "./mrbg/mrbgRedux";
import BA_style from "../static/css/MP_BillAmount.module.css"
import mrbgS2S from '../mrbgLib/mrbgS2S.js';

function BillAmount(){

	const
		[activePopup,setActivePopUp] = useState(false),
		[activeForms,setActiveForms] = useState(),
		[amounts,setAmount] = useState( {} ),
		[dataKey,setDataKey] = useState(null),
		[loader,setLoader] = useState(false),
		[formSetting,setFormSetting] = useState({});

	useEffect(()=>{
		if( activeForms?.includes('apoResFrame') ){
			setActivePopUp(true)
			setDataKey('apoRes')
		}
		else if( activeForms?.includes('apoResUpdFrame') ){
			setActivePopUp(true)
			setDataKey('apoResUpd')
		}
		else{
			setDataKey(null);
			setActivePopUp(false)
		}

	},[activeForms])
	useEffect(()=>{
		if( dataKey ){
			const unsubscribe = mrbgStore.subscribe(()=>{
				setFormSetting( mrbgStore.getState().formsSettings[dataKey] );
			})
			return () =>unsubscribe();
		}
	}, [dataKey]);
	useEffect(() => {

		var MD = null;
		if(
			dataKey === 'apoRes'                                                 &&
			formSetting.STV?.areID?.length                                       &&
			Object.values(formSetting.sundryField?.beginDateTime||{})?.length &&
			formSetting.STV?.cliID?.length
		){
			MD = new FormData();
			MD.append( 'formID'       , 'apoRes' );
			MD.append( 'cliID'        , formSetting.STV.cliID[0] );
			MD.append( 'areID'        , formSetting.STV.areID );
			MD.append( 'beginDateTime', Object.values(formSetting.sundryField.beginDateTime) );
			MD.append( 'amount'       , formSetting.sundryField.amount||0 );
		}
		else if(
			dataKey === 'apoResUpd'                &&
			formSetting.hideInp?.id                &&
			formSetting.hideInp?.cliID             &&
			formSetting.STV?.areID?.length         &&
			formSetting.sundryField?.beginDateTime
		){
			MD = new FormData();
			MD.append( 'formID'       , 'apoResUpd' );
			MD.append( 'apoSesID'     , formSetting.hideInp.id );
			MD.append( 'cliID'        , formSetting.hideInp.cliID );
			MD.append( 'areID'        , formSetting.STV.areID );
			MD.append( 'beginDateTime', formSetting.sundryField.beginDateTime );
			MD.append( 'amount'       , formSetting.sundryField.amount||0 );
		}

		if( MD ){
			setLoader(true);
			mrbgS2S(null, MD, 'CBA', 'apoSes', false )
				.then( setLoader(false) );
		}

	}, [dataKey,formSetting]);
	useEffect(()=>{
		const unsubscribe = mrbgStore.subscribe(()=>{
			setActiveForms( mrbgStore.getState().activeForms )
			setAmount     ( mrbgStore.getState().mrbgVars.billAmount )
		})
		return () =>unsubscribe();
	},[])

	if( !activePopup )
		return <ul id={BA_style.billAmount}></ul>;

	return(
		<ul id={BA_style.billAmount} data-id="activeBilAmount" className={`${BA_style.flexRow} ${activePopup? BA_style.active:''}`}>
			<li>
				<label>مبلغ کل:</label>
				<span data-descontent="Totla Amount" data-mobcontent=":مبلغ کل">
          {
						(amounts && Object.hasOwn(amounts,dataKey) && amounts[dataKey].totalAmount!==null)? amounts[dataKey].totalAmount.toPrice(): ''
					}
        </span>
			</li>
			<li>
				<label>تخفیف+معوق:</label>
				<span data-descontent="Discount Amount" data-mobcontent=":تخفیف+معوق">
          {
						(amounts && Object.hasOwn(amounts,dataKey) && amounts[dataKey].discount!==null)? amounts[dataKey].discount.toPrice(): ''
					}
        </span>
			</li>
			<li>
				<label>مبلغ نهایی:</label>
				<span data-descontent="Final Amount" data-mobcontent=":مبلغ نهایی">
          {
						(amounts && Object.hasOwn(amounts,dataKey) && amounts[dataKey].finalAmount!==null)? amounts[dataKey].finalAmount.toPrice(): ''
					}
        </span>
			</li>
			<li>
				<label>مبلغ پرداختی:</label>
				<span data-descontent="payed amount" data-mobcontent=":مبلغ پرداختی">
          {
						(amounts && Object.hasOwn(amounts,dataKey) && amounts[dataKey].paidAmount!==null)? amounts[dataKey].paidAmount.toPrice(): ''
					}
        </span>
			</li>
			<li>
				<label>درصد پرداختی:</label>
				<span data-descontent="Payed Percent" data-mobcontent=":درصد پرداختی">
          {
						(amounts && Object.hasOwn(amounts,dataKey) && amounts[dataKey].percent!==null)? `${amounts[dataKey].percent}%`: ''
					}
        </span>
			</li>
			<li>
				<label>مانده:</label>
				<span data-descontent="Remind" data-mobcontent=":مانده">
          {
						(amounts && Object.hasOwn(amounts,dataKey) && amounts[dataKey].remainder!==null)? amounts[dataKey].remainder.toPrice(): ''
					}
        </span>
			</li>
			<li id={BA_style.billAmountLoader} style={{display:loader?'block':'none'}}>
				<svg viewBox="0 0 30 30">
					<circle cx="15" cy="15" r="12"></circle>
				</svg>
			</li>
		</ul>
	)
}
export default BillAmount;